export enum VenueFinderLanguage {
  czech = 'cs',
  english = 'en',
}
